import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IProcurementRequirementItem } from 'types/lot/procurement-requirement-items'

type ProcurementRequirementItemInput = {
  procurementId: string
  itemId?: string
}

export const procurementRequirementItemsApi = createApi({
  reducerPath: 'procurementRequirementItems',
  baseQuery,
  endpoints: (builder) => ({
    ProcurementRequirementItems: builder.query<
      IProcurementRequirementItem[],
      ProcurementRequirementItemInput
    >({
      query: ({ procurementId }) => ({
        url: `/procurements/${procurementId}/items`,
      }),
    }),

    ProcurementRequirementItem: builder.query<
      IProcurementRequirementItem,
      ProcurementRequirementItemInput
    >({
      query: ({ procurementId, itemId }) =>
        `/procurements/${procurementId}/items/${itemId}`,
    }),

    createProcurementRequirementItem: builder.mutation<
      IProcurementRequirementItem,
      Partial<IProcurementRequirementItem> & ProcurementRequirementItemInput
    >({
      query: (body) => ({
        url: `/procurements/${body.procurementId}/items`,
        body,
        method: 'post',
      }),
    }),

    deleteProcurementRequirementItem: builder.mutation<
      void,
      ProcurementRequirementItemInput
    >({
      query: ({ procurementId, itemId }) => ({
        url: `/procurements/${procurementId}/items/${itemId}`,
        method: 'delete',
      }),
    }),
  }),
})

export const {
  useProcurementRequirementItemsQuery,
  useProcurementRequirementItemQuery,
  useCreateProcurementRequirementItemMutation,
  useDeleteProcurementRequirementItemMutation,
} = procurementRequirementItemsApi
